// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"5295ffe8","772":"96fe11fe","869":"d8363d31"}[chunkId] + ".chunk.js";
};